function qinticIn(t) {
  return t * t * t * t * t
}

module.exports = qinticIn